import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import axios from "axios";
import { useMyContext } from "../../components/Provider/CommonProvider";


const Footer = () => {
  const { accessToken } = useMyContext();
  const [subFooterContent, setSubFooterContent] = useState("");

  // const access_token = localStorage.getItem("access_token");


  const headers = {
    "Content-Type": "application/json",
    Authorization: "Bearer " + accessToken,

    Accept: "application/json",
  };

  useEffect(() => {
    const fetchSubFooter = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_Baseurl}/admin/settings/sub-footer-menu`,
          { headers }
        );
        if (response?.data?.status) {
          setSubFooterContent(response?.data?.data);
        }
      } catch (error) {
        console.error('Error fetching sub footer content:', error);
      }
    };

    fetchSubFooter();
  }, []);


  return (
    <div>
      <div className="admin-footer theme-bg-color position-fixed w-100">
        <div className="row copyrights1 col-12">
          <div className="">
            {/* <ul className="list-inline mb-0">
                <li className="list-inline-item">
                  <Link to="/terms-and-conditions" className="copyrights1Link">
                    Terms and Conditions
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link to="/privacy-policy" className="copyrights1Link">
                    Privacy Policy
                  </Link>
                </li>
              </ul> */}
          </div>
          <div className=" text-right copyrights" dangerouslySetInnerHTML={{ __html: subFooterContent }} />
        </div>

      </div>
    </div>
  );
};

export default Footer;
